import {Action} from '@ngrx/store';
import {AusmitError} from "../../shared/interfaces";
import {CriteriaModel} from "../../shared/interfaces/CriteriaModel";

export enum ActionTypes {
	GetStudiosSilently = 'GetStudiosSilently',

	GetStudios = 'GetStudios',
	GetStudiosSuccess = 'GetStudiosSuccess',
	GetStudiosError = 'GetStudiosError',

	DisLikeStudio = 'DisLikeStudio',
	LikeStudio = 'LikeStudio',
	LikeStudioSuccess = 'LikeStudioSuccess',
	LikeStudioError = 'LikeStudioError',

	PostComment = 'PostComment',
	PostCommentSuccess = 'PostCommentSuccess',
	PostCommentError = 'PostCommentError',
}

export class GetStudios implements Action {
	readonly type = ActionTypes.GetStudios;

	constructor(public payload: CriteriaModel) {
	}
}

export class GetStudiosSilently implements Action {
	readonly type = ActionTypes.GetStudiosSilently;

	constructor(public payload: any) {
	}
}

export class GetStudiosSuccess implements Action {
	readonly type = ActionTypes.GetStudiosSuccess;

	constructor(public payload: any) {
	}
}

export class GetStudiosError implements Action {
	readonly type = ActionTypes.GetStudiosError;

	constructor(public payload: AusmitError) {
	}
}

export class PostComment implements Action {
	readonly type = ActionTypes.PostComment;

	constructor(public payload: { studioId: string, commentPayload: any }) {
	}
}

export class PostCommentSuccess implements Action {
	readonly type = ActionTypes.PostCommentSuccess;

	constructor(public payload: any) {
	}
}

export class PostCommentError implements Action {
	readonly type = ActionTypes.PostCommentError;

	constructor(public payload: AusmitError) {
	}
}

export class LikeStudio implements Action {
	readonly type = ActionTypes.LikeStudio;

	constructor(public payload: { studioId: string }) {
	}
}

export class DisLikeStudio implements Action {
	readonly type = ActionTypes.DisLikeStudio;

	constructor(public payload: { studioId: string; likeId: string }) {
	}
}

export class LikeStudioSuccess implements Action {
	readonly type = ActionTypes.LikeStudioSuccess;

	constructor(public payload: any) {
	}
}

export class LikeStudioError implements Action {
	readonly type = ActionTypes.LikeStudioError;

	constructor(public payload: AusmitError) {
	}
}

export type Actions =
	| GetStudiosSilently
	| GetStudios
	| GetStudiosSuccess
	| GetStudiosError
	| DisLikeStudio
	| LikeStudio
	| LikeStudioSuccess
	| LikeStudioError
	| PostComment
	| PostCommentSuccess
	| PostCommentError;

